import { render, staticRenderFns } from "./resultsTable.vue?vue&type=template&id=3d4dac31"
import script from "./resultsTable.vue?vue&type=script&lang=js"
export * from "./resultsTable.vue?vue&type=script&lang=js"
import style0 from "./resultsTable.vue?vue&type=style&index=0&id=3d4dac31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports